export enum CupTypes {
  ONLINE = 'online',
  OFFLINE = 'offline',
}
